import { render } from "./FooterLinks.vue?vue&type=template&id=4de63fec&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=4de63fec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de63fec"]])

export default __exports__